import React from 'react'

export default () => (
  <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 14L15.5 7.5M15.5 7.5L9 0.999999M15.5 7.5L5.68248e-07 7.5" stroke="#003A80" strokeWidth="2"/>
  </svg>
)
